/**
 * Minimal route transition shell — keeps layout stable without pulling heavy UI.
 */
export default function RouteFallback() {
  return (
    <div
      className="routeFallback"
      aria-busy="true"
      aria-label="Loading page"
      style={{
        minHeight: "45vh",
        width: "100%",
        background: "var(--surface-muted)",
        opacity: 0.75,
      }}
    />
  );
}
